import { collapseEmits as n, collapseProps as c } from "./index611.js";
import { defineComponent as i, openBlock as f, createElementBlock as u, normalizeClass as d, unref as C, renderSlot as _ } from "vue";
import { useCollapse as v, useCollapseDOM as E } from "./index729.js";
var h = /* @__PURE__ */ i({
  name: "ElCollapse",
  __name: "collapse",
  props: c,
  emits: n,
  setup(o, { expose: s, emit: t }) {
    const e = o, l = t, { activeNames: a, setActiveNames: r } = v(e, l), { rootKls: p } = E(e);
    return s({
      /** @description active names */
      activeNames: a,
      /** @description set active names */
      setActiveNames: r
    }), (m, k) => (f(), u(
      "div",
      {
        class: d(C(p))
      },
      [
        _(m.$slots, "default")
      ],
      2
      /* CLASS */
    ));
  }
});
export {
  h as default
};
